<template>
  <div id="cup_h5Comp">
    <span class="dev">待完善</span>
  </div>
</template>

<script>
export default {
  name: 'cup_h5Comp',
  data() {
    return {}
  },
}
</script>

<style lang="scss" scoped>
.dev {
  display: block;
  text-align: center;
  font-size: 2.083vw;
  padding-top: 6.25vw;
}
</style>
